import styled from 'styled-components/macro';

export const ContentHolder = styled.div`
  position: relative;
  width: 100%;
  margin: 0 0 25px;
`;

export const Header = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 0 15px;
`;

export const Heading = styled.strong`
  display: block;
  font-size: 14px;
  line-height: 20px;
  text-transform: capitalize;
  margin: 0;
`;
